export default __webpack_public_path__ + "static/media/active.ea262c0d.svg";